import { render, staticRenderFns } from "./account.vue?vue&type=template&id=304becb2&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"
import style0 from "./account.vue?vue&type=style&index=0&id=304becb2&prod&scoped=true&lang=css"
import style1 from "./account.vue?vue&type=style&index=1&id=304becb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304becb2",
  null
  
)

export default component.exports